<template>
    <div class="col-12 person-container">
        <div class="col-12">
            <div class="row" v-if="name">
                <div class="col-12 d-flex flex-row">
                    <h4 class="flex-fill">{{name}}</h4>
                    <div
                            class="btn-group btn-group-sm"
                            role="group"
                            aria-label="Basic example"
                            v-if="hasRole('editor')"
                            @click="onEdit"
                    >
                        <button type="button" class="btn btn-warning">
                            <i class="material-icons">
                                create
                            </i>
                            Editeaza
                        </button>
                        <button
                                type="button"
                                class="btn btn-danger"
                                @click.stop="onDelete"
                        >
                            <i class="material-icons">
                                delete
                            </i>
                            Sterge
                        </button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p>Actualizat la {{updated_at}}</p>
                </div>
            </div>
            <div class="row" v-if="organization">
                <div class="col-3 text-muted">Organizatie</div>
                <div class="col-9" v-emphasise="search">
                    {{organization}}
                </div>
            </div>
            <div class="row" v-if="comment">
                <div class="col-12 small text-muted" v-emphasise="search">
                    {{comment}}
                </div>
            </div>
        </div>
        <div class="col-12 subscriptions">
            <h5>Subscriptii</h5>
        </div>
        <div class="col-12">
            <Contact
                    v-for="contact in orderedContacts"
                    :id="contact.id"
                    :key="contact.id"
                    :type="contact.type"
                    :handler="contact.handler"
                    :lists="contact.lists"
                    :is_active="contact.is_active"
                    :priority="contact.priority"
                    ref="contacts"
            />
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import Contact from './Contact'
    export default {
        components: {
            Contact
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            organization: {
                type: String,
                required: false
            },
            comment: {
                type: String,
                required: false
            },
            contacts: {
                required: false
            },
            updated_at: {
                type: String,
                required: false
            }
        },
        methods: {
            onEdit(){
                this.$emit('editPerson')
            },
            onDelete(){
                this.$emit('deletePerson')
            }
            // doDelete(){
            //     this.onDelete(this)
            // },
        },
        computed: {
            ... mapState('persons', ['search']),
            ... mapGetters('auth', ['hasRole']),
            orderedContacts: function(){
                return [...this.contacts].sort((a,b) => {
                    if(a.handler > b.handler){
                        return 1
                    }
                    else if(a.handler === b.handler){
                        return 0
                    }
                    return -1
                })
            }
        }
    }
</script>
<style>
    .emphasis {
        color: red;
        font-weight: bold;
    }
</style>
<style scoped>
.subscriptions > h5{
    margin-top: 10px;
    font-size: 16px;
    border-bottom: 1px solid #f0f0f0;
}
.person-container{
    padding: 10px 0px;
    background-color: #fdfdfd;
    border: 1px solid #dfdfdf;
    margin-bottom: 20px;
    border-radius: 5px;
}
</style>